import Lottie from 'lottie-react'
import { DARK_TREATMENTS, type DarkTreatment } from './darkTreatment'
import cryptoWalletAnimation from '../../assets/animations/crypto-wallet.json'

interface Web3IconProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  /**
   * How the icon handles a dark surface. Defaults to 'none', which is what this
   * component did before the prop existed: no filter at all. It gets away with that
   * because the artwork is mostly blue, which reads on either surface, unlike the
   * mostly-black icons that need a treatment.
   */
  darkTreatment?: DarkTreatment
}

const Web3Icon = ({ className = 'h-8 w-8', darkTreatment = 'none', ...props }: Web3IconProps) => {
  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }} {...props}>
      <div className={`${DARK_TREATMENTS[darkTreatment]} w-full h-full`}>
        <Lottie
          animationData={cryptoWalletAnimation}
          loop={true}
          autoplay={true}
          className="w-full h-full"
        />
      </div>
    </div>
  )
}

export default Web3Icon